import NAV_DATA from '@zola-helpers/client/dist/es/constants/navConstants';

import { getModuleGroups } from 'selectors/ModuleGroupSelectors';
import { getUserContext, getChecklistId } from 'selectors/user';

import mapNavTypeToModule from 'util/mapNavTypeToModule';
import * as MegaMenusConstants from 'util/constants/megaMenuModuleGroups';

// Add cases as necessary
const {
  PRIMARY: { ADVICE },
} = NAV_DATA;

const filterMegaMenuModulesPerNavType = (state, activeNavType) => {
  const views = getModuleGroups(state);
  const allModulesByNavType = mapNavTypeToModule(views, activeNavType);
  switch (activeNavType) {
    case ADVICE: {
      const userContext = getUserContext(state);
      const hasChecklist = getChecklistId(state);
      return allModulesByNavType.filter((module) => {
        if (!userContext.is_guest) {
          if (hasChecklist) return module.title === MegaMenusConstants.CHECKLIST_ACTIVATED;
          return module.title === MegaMenusConstants.CHECKLIST_NOT_ACTIVATED;
        }
        return module.title === MegaMenusConstants.ADVICE_GUEST;
      });
    }
    default:
      return allModulesByNavType;
  }
};

export default filterMegaMenuModulesPerNavType;
